export default __webpack_public_path__ + "static/media/sign-up.8f5d3141.jpg";